import axios from "axios";
import Config from "./Config";

const { API_BASE_URL } = Config;
const headers = {
    "Content-Type": "application/json",
};

// ---------------------------Product ------------------------
// =========================Get All Product=========================
export const getAllProduct = async (CountryId, StateId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/all-product`, {
            headers,
            params: {
                CountryId,
                StateId
            }
        });
        if (response.data.status === true) {
            return response.data.responseData;
        } else {
            throw new Error(response.data.message || "API returned an error");
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        throw error;
    }
};

// ----------------------getProductbyId----------------
export const getProductById = async (Id, CountryId, StateId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/product/${Id}`, {
            headers,
            params: {
                CountryId,
                StateId
            }
        });
        if (response.data.status === true) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with API message
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        throw error;
    }
};

// ----------------------Addtocart----------------
export const AddToCart = async (data, token) => {
    const TOKEN = Config.getToken();
    const headers = {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
    };
    try {
        const response = await axios.post(`${API_BASE_URL}/cart/add`, data, {
            headers,
        });
        if (
            response.data.status === true
        ) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with API message
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        if (error.response?.data?.message === "Unauthorized - Token verification failed") {
            Config.handleUnauthorized();
            return;
        }
        throw error;
    }
};
// ----------------------Updatecart----------------
export const UpdateCart = async (data, token) => {
    const TOKEN = Config.getToken();
    const headers = {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
    };
    try {
        const response = await axios.put(`${API_BASE_URL}/cart/update`, data, {
            headers,
        });
        if (
            response.data.status === true
        ) {
            return response.data;
        } else {
            throw new Error(response.data.message); // Throw error with API message
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        if (error.response?.data?.message === "Unauthorized - Token verification failed") {
            Config.handleUnauthorized();
            return;
        }
        throw error;
    }
};

// =========================Get Cart Product=========================
export const getCartProduct = async (CountryId, StateId) => {
    const TOKEN = Config.getToken();
    const headers = {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
    };
    try {
        const response = await axios.get(`${API_BASE_URL}/cart/get`, {
            headers,
            params: {
                CountryId,
                StateId
            }
        });
        if (response.data.status === true) {
            return response.data;
        } else {
            throw new Error(response.data.message || "API returned an error");
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        if (error.response?.data?.message === "Unauthorized - Token verification failed") {
            Config.handleUnauthorized();
            return;
        }
        throw error;
    }
};
// =========================delete Cart Product=========================
export const deleteCartProduct = async (Id, CountryId, StateId) => {
    const TOKEN = Config.getToken();
    const headers = {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
    };
    try {
        const response = await axios.delete(`${API_BASE_URL}/cart/delete`, {
            headers,
            data: {
                Id,
                CountryId,
                StateId
            }
        });
        if (response.data.status === true) {
            return response.data.responseData;
        } else {
            throw new Error(response.data.message || "API returned an error");
        }
    } catch (error) {
        console.error(
            "Error fetching admin data:",
            error.response || error.message || error
        );
        if (error.response?.data?.message === "Unauthorized - Token verification failed") {
            Config.handleUnauthorized();
            return;
        }
        throw error;
    }
};

// =========================Get Cart Counter=========================
export const getCartCounter = async (CountryId, StateId) => {
    const TOKEN = Config.getToken();
    const headers = {
        Authorization: `Bearer ${TOKEN}`,
        "Content-Type": "application/json",
    };
    try {
        const response = await axios.get(`${API_BASE_URL}/counter`, {
            headers,
        });
        if (response.data.status === true) {
            return response.data;
        } else {
            throw new Error(response.data.message || "API returned an error");
        }
    } catch (error) {
        console.error("Error fetching cart counter:", error);
        if (error.response?.data?.message === "Unauthorized - Token verification failed") {
            Config.handleUnauthorized();
            return;
        }
        throw error;
    }
};